// Hideo - the legal pages before a profile is chosen (docs/architecture.md, "Navigation"). A legal page opened before a
// profile was chosen in this session (directly: Google's consent screen, a link, a new browser; or from the profile
// picker's footer) is shown on its own: the profile picker does not cover it, the app around it (menus, create button)
// is hidden, the global shortcuts are off, and a bar at the top opens the app (LegalPage.vue). Leaving it for a page of
// the app shows the profile picker, as at start-up. Once a profile is chosen, legal pages are ordinary pages of the app.
import type { RouteLocationNormalized } from 'vue-router'
import { router } from '../router'
import { isLegalPath } from '../navigation'
import { usePickerStore } from '../stores/picker'
import { useDialogsStore } from '../stores/dialogs'

/** A legal page is shown on its own (reactive: the route and the picker store). Before the router's first navigation
 *  has finished, the address decides */
export function legalOnly(): boolean {
  if (usePickerStore().entered) return false
  const r = router.currentRoute.value
  return r.matched.length ? !!r.meta.legal : isLegalPath(location.pathname)
}

/** After every navigation (src/router.ts): a legal page closes the profile picker (opened from its footer, or Back to
 *  it); leaving a legal page for the app before a profile was chosen shows the picker again */
export function afterLegalNavigation(to: Pick<RouteLocationNormalized, 'meta'>, from: Pick<RouteLocationNormalized, 'meta'>): void {
  const picker = usePickerStore()
  if (to.meta.legal) {
    if (picker.isOpen()) useDialogsStore().hide('picker')
  } else if (from.meta.legal && !picker.entered) picker.show()
}
